module.exports = __webpack_public_path__ + "img/IMG_1627_Wood.df3edd96.jpg";